import { createSelector } from 'reselect';

const getAudit = (state) => state.audit.list.data;
const getAuditIsLoading = (state) => state.audit.list.isLoading;
const getAuditError = (state) => state.audit.list.hasError;

/**
 * SELECTORS
 */

// Audit
export const selectAudit = createSelector([getAudit], (audit) => audit);

export const selectAuditHasError = createSelector([getAuditError], (error) => error);

export const selectAuditIsLoading = createSelector([getAuditIsLoading], (isLoading) => isLoading);
